import { getTenderTranslator, tenderLocale, tenderStatusLabel } from "../pages/tenderMessages";

export const managedByAdmin = (record) => Boolean(record?.managed_by_admin || record?.corporate_catalog_id);

export function tenderPeriod(tender, today = localDate()) {
  if (tender?.is_active === false) return "archived";
  if (tender?.starts_on?.slice(0, 10) > today) return "future";
  if (tender?.ends_on && tender.ends_on.slice(0, 10) < today) return "expired";
  return "active";
}

export const localDate = (date = new Date()) => {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
};

export const apiError = (error, languageId = "es") => getTenderTranslator(languageId)(typeof error === "string" ? error : error?.response?.data?.error || error?.response?.data?.message || "Unable to complete the operation.");

export function claimsCsv(rows, languageId = "es") {
  const t = getTenderTranslator(languageId);
  const columns = [
    ["Delivery note", "delivery_note_number"], ["Date", "date"], ["Supplier", "supplier_name"],
    ["Code", "item_code"], ["Item", "item_name"], ["Tendered price", "tender_price"],
    ["Actual price", "received_price"], ["Quantity", "quantity"], ["Unit difference", "unit_difference"],
    ["Total difference", "total_difference"], ["Currency", "currency"], ["Difference", "status"], ["Delivery note status", "document_status"],
  ];
  const cell = (value) => {
    let text = String(value ?? "");
    if (/^[=+\-@\t\r]/.test(text) && !/^-?\d+(\.\d+)?$/.test(text)) text = `'${text}`;
    return `"${text.replace(/"/g, '""')}"`;
  };
  return "\ufeff" + [columns.map(([title]) => cell(t(title))), ...rows.map((row) => columns.map(([, key]) => cell(key === "status" || key === "document_status" ? tenderStatusLabel(row[key], languageId) : row[key])))].map((row) => row.join(";")).join("\r\n");
}

export function downloadClaims(rows, languageId = "es") {
  const url = URL.createObjectURL(new Blob([claimsCsv(rows, languageId)], { type: "text/csv;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = `${tenderLocale(languageId) === "es-ES" ? "reclamaciones-licitaciones" : "tender-claims"}-${localDate()}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
